// extracted by mini-css-extract-plugin
export default {"btnpwd":"_2b2c7e7fcf"};